import {Component, Input, OnInit} from '@angular/core';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-offer-modification-price',
  templateUrl: './offer-modification-price.component.html',
  styleUrls: ['./offer-modification-price.component.scss']
})
export class OfferModificationPriceComponent implements OnInit {

  @Input() price: number;
  @Input() loading: boolean = false;

  get knownPrice(): boolean {
    return isNotNullOrUndefined(this.price);
  }

  constructor() { }

  ngOnInit() {
  }

}
